import css from './index.module.scss';

export default function InstallationTips({ callback }: any) {
    return (
        <div className={`installation-tips ${css['installation-tips']}`}>
            <div className="tips-box">
                <div className="tips-header">
                    <p className="header-title">Get a FREE Installation Consult</p>
                    <span className="header-close" onClick={callback}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>
                <div className="tips-content">
                    <p>Free installation consulting is available.</p>
                    <p>
                        Just contact our support team: <span className="tips-content-mailbox">support@ecoflow.com</span>
                    </p>
                    <p>*Service only includes consultation, not installation.</p>
                </div>
            </div>
            <style global jsx>
                {`
                    .ecoflow-frame-header {
                        z-index: 100 !important;
                    }
                `}
            </style>
        </div>
    );
}
